export const delay = (time) => new Promise(resolve => {
    setTimeout(resolve, time)
})


// WEBPACK FOOTER //
// ./src/utils/utils.js